export const META_TAG = {
    home: {
        title: "The Door Man -  La nouvelle expérience immobilière.",
        description: "THE DOOR MAN, c'est des clients contents. Des Conseillers en immobilier partenaires de confiance ; tout pour vendre ou louer un bien immobilier en toute tranquillité d’esprit, dans le délai souhaité et au meilleur prix possible !"
    },
    concept: {
        title: "The Door Man - Un concept innovant et efficient pour une nouvelle approche immobilière",
        description: "THE DOOR MAN c’est vivre une expérience immobilière moderne, innovante et efficiente par une nouvelle approche de la transaction immobilière et du partage intégral de son mandat de vente."
    },
    club: {
        title: "The Door Man - Une concession agréable et convivial pour travailler, échanger et partager",
        description: "THE DOOR MAN est un espace où se côtoient les différents acteurs de l’immobilier et son éco système, afin qu’ils puissent disposer d’un lieu agréable et convivial pour travailler, échanger et partager."
    },
    conciergerie: {
        title: "The Door Man - La conciergerie, un service immobilier d'accompagnement unique en France",
        description: "THE DOOR MAN accompagne ses clients dans tout ce qui a un rapport avec leur logement, de l'aide à domicile à des questions d’ordre fiscales, financières, voire même une interrogation en cas de cambriolage..."
    },
    saler: {
        title: "The Door Man - Un interlocuteur unique pour une diffusion d'un bien auprés de tous les professionnels immobiliers",
        description: "THE DOOR MAN devient l’interlocuteur unique du vendeur pour une diffusion de son bien à vendre auprès de tous les professionnels immobiliers du marché local."
    },
    lessor: {
        title: "The Door Man - Un reseau de professionnels immobiliers partenaires à votre service",
        description: "THE DOOR MAN est un professionnel de la gestion locative nous suivons une procédure très aboutie qui a fait ses preuves tant pour la gestion que pour la location."
    },
    search: {
        title: "The Door Man - Rechercher un bien dans notre écosystème",
        description: "THE DOOR MAN vous propose d'utiliser son savoir faire sur la recherche d'un bien qu'il soit à louer ou à vendre  "
    },
    contact: {
        title: "The Door Man - Contactez nous et n'hésistez pas à poser vos questions",
        description: "THE DOOR MAN reste à votre ecoute vos besoins, si vous avez une question sur votre logement, n'hesitez pas à nous contacter et nos équipes reviendront vesr vous dans les meilleurs delais."
    },
    faq: {
        title: "The Door Man - Questions et réponses sur le fonctionnement du réseau national immobilier The Door Man",
        description: "THE DOOR MAN répond à vos questions que vous soyez un acheteur, un vendeur, un partenaire ou sur le système de fonctionnement de son concept."
    },
    blog: {
        title: "The Door Man - Retrouvez nos derniers actualités immo",
        description: "THE DOOR MAN, c'est des clients contents. Des Conseillers en immobilier partenaires de confiance ; tout pour vendre ou louer un bien immobilier en toute tranquillité d’esprit, dans le délai souhaité et au meilleur prix possible !"
    }
}
